module.exports = "<!-- TIMECHART -->\n<div class=\"boo-align-center boo-row\">\n    <h2 class=\"boo-title-bottom\" [innerHTML]=\"title\"></h2>\n    <h2 style=\"font-size: 22px\" [innerHTML]=\"subtitle\"></h2>\n</div>\n\n<google-chart [data]=\"chartData\" (chartSelect)='chartSelect($event)'></google-chart>\n\n<!-- END // TIMECHART -->"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/ui/home-timechart/home-timechart.component.html
// module id = ./src/app/components/ui/home-timechart/home-timechart.component.html
// module chunks = main